// Aucun emploi du temps configuré par défaut
export const defaultSchedules = [];
